import { Injectable } from '@angular/core';
import { AngularFire } from 'angularfire2';
import { AuthData } from '../providers/auth';
import { Utilities } from '../providers/utilities';
import * as firebase from 'firebase';

@Injectable()

export class EventData {

  constructor(public af: AngularFire, public auth: AuthData, public ut: Utilities) {}

  getListener(client, tokenEvent: string, mod: string) {
    return this.af.database.object( '/Clients/' + client.url + '/EventList/' + tokenEvent + '/modules/' + mod)
  }

  getListEvents(client, state=true, except=false) {
    let dataReturn = [];
    let q = firebase.database().ref().child('/Clients/' + client.url + '/EventList').orderByChild('state').equalTo(state);

    return new Promise((resolve, reject) => {
      q.once('value').then((snapshot) => {
        snapshot.forEach((childSnapshot) => {
          if (except) {
            if (childSnapshot.val().id != except) {
              dataReturn.push(childSnapshot.val());
            }
          } else {
            dataReturn.push(childSnapshot.val());
          }
        });

        resolve(dataReturn);
      })
      .catch(error => {
        reject(error);
      });
    })
  }

  setTransactionDashboard(client: any, event: any, child) {
    // Increase counter dashboard event
    firebase.database().ref().child('/Clients/' + client.url + '/___Dashboard/' + event.id + '/' + child).
    transaction(function(currentCount) {
      return currentCount + 1;
    });
  }

  setTransactionOpinometer(type, client, opinometer, question, key) {
    switch (type) {
      case 'multiple':
      case 'multipleUnique':
        firebase.database().ref().child('/Clients/' + client.url + '/___OpinometerStats/' + opinometer.id + '/' + question.id + '/' + key).transaction(function(currentCount) {
          return currentCount + 1;
        });
      break;
      case 'open':
        firebase.database().ref().child('/Clients/' + client.url + '/___OpinometerStats/' + opinometer.id + '/' + question.id).transaction(function(currentCount) {
          return currentCount + 1;
        });
      break;
      case 'ranking':
        firebase.database().ref().child('/Clients/' + client.url + '/___OpinometerStats/' + opinometer.id + '/' + question.id).transaction(function(currentCount) {
          if (currentCount) {
            return (parseFloat(currentCount) + parseFloat(question.answerData)) / 2;
          } else {
            return question.answerData;
          }
        });
      break;
    }

    return true;
  }

  getListDiary(client, tokenEvent) {
    return this.af.database.list( 'Clients/' + client.url + '/Events/' + tokenEvent + '/Diary', {
      query: {
        orderByChild: 'state',
        equalTo: true
      }
    });
  }

  getListSponsor(client, tokenEvent) {
    return this.af.database.list( 'Clients/' + client.url + '/Events/' + tokenEvent + '/Sponsors', {
      query: {
        orderByChild: 'state',
        equalTo: true
      }
    });
  }

  getListSpeaker(client, tokenEvent) {
    return this.af.database.list( 'Clients/' + client.url + '/Events/' + tokenEvent + '/Speakers', {
      query: {
        orderByChild: 'order'
      }
    });
  }

  getListMessages(client, token_event, typeMessage) {
    return this.af.database.list('/Clients/' + client.url + '/Events/' + token_event + '/Messages/' + typeMessage, {
      query: {
        orderByChild: 'state',
        equalTo: true
      }
    });
  }

  getSponsor(client, sponsorId) {
    return this.af.database.object( 'Clients/' + client.url + '/Sponsors/' + sponsorId);
  }

  getSpeaker(client, speakerId) {
    return this.af.database.object( 'Clients/' + client.url + '/Speakers/' + speakerId);
  }

  getNow(client, tokenEvent) {
    return this.af.database.object( 'Clients/' + client.url + '/Events/' + tokenEvent + '/Now');
  }

  getActivity(client, tokenEvent) {
    return this.af.database.object( 'Clients/' + client.url + '/Events/' + tokenEvent + '/Activity');
  }

  getStands(client) {
    return this.af.database.list( 'Clients/' + client.url + '/Showcases');
  }

  getMessages(client, userSender, userAddressee) {
    return this.af.database.object( 'Clients/' + client.url + '/___NetworkingMessages/' + userSender + '/' + userAddressee);
  }

  getCatalogs(client, tokenEvent) {
    return this.af.database.list( 'Clients/' + client.url + '/Events/' + tokenEvent + '/Catalogs');
  }

  getCatalogsTop(client, tokenEvent) {
    return this.af.database.list( 'Clients/' + client.url + '/Events/' + tokenEvent + '/Catalogs', {
      query: {
        orderByChild: 'isTop',
        equalTo: true
      }
    });
  }

  getMap(client, tokenEvent) {
    return this.af.database.object( 'Clients/' + client.url + '/Events/' + tokenEvent + '/Map');
  }

  getEmbed(client, tokenEvent) {
    return this.af.database.object( 'Clients/' + client.url + '/Events/' + tokenEvent + '/Embed');
  }

  getStreaming(client, tokenEvent) {
    return this.af.database.object( 'Clients/' + client.url + '/Events/' + tokenEvent + '/Streaming');
  }

  getSocial(client, tokenEvent) {
    return this.af.database.object( 'Clients/' + client.url + '/Events/' + tokenEvent + '/Social');
  }

  getDiary(client, tokenEvent, tokenDiary) {
    return this.af.database.object( 'Clients/' + client.url + '/Events/' + tokenEvent + '/Diary/' + tokenDiary)
  }

  getCatalog(client, tokenCatalog) {
    return this.af.database.object( 'Clients/' + client.url + '/Catalogs/' + tokenCatalog)
  }

  getPayments(client, userId) {
    console.log('Clients/' + client.url + '/___PayUsers/' + userId)
    return this.af.database.list('Clients/' + client.url + '/___PayUsers/' + userId);
  }

  getOpinometerPublish(client, tokenEvent) {
    return this.af.database.object('Clients/' + client.url + '/EventList/' + tokenEvent + '/opinometerNow');
  }

  getQuestionsPublish(client, tokenEvent) {
    return this.af.database.list('Clients/' + client.url + '/Events/' + tokenEvent + '/Question');
  }

  getOpinometerQuestions(client, opinometerId) {
    return this.af.database.list('Clients/' + client.url + '/Opinometers/' + opinometerId + '/Questions');
  }

  getOpinometerStats(client, opinometerId) {
    return this.af.database.list('Clients/' + client.url + '/___OpinometerStats/' + opinometerId);
  }

  getMyContacts(client, userId) {
    return this.af.database.list( 'Clients/' + client.url + '/___NetworkingUsers/' + userId)
  }

  getCatalogBadge(client, userId) {
    return this.af.database.list( 'Clients/' + client.url + '/___CartUsers/' + userId);
  }

  getUser(client, userId) {
    return this.af.database.object( 'Clients/' + client.url + '/Users/' + userId);
  }

  getData(client: any, tokenEvent: string, component: string, equalToChild: any = false) {
    let dataReturn = [];
    let dataRef;

    if (equalToChild) {
      dataRef = firebase.database().ref().child('/Clients/' + client.url + '/Events/' + tokenEvent + '/' + component).orderByChild(equalToChild.child).equalTo(equalToChild.value);
    } else {
      dataRef = firebase.database().ref().child('/Clients/' + client.url + '/Events/' + tokenEvent + '/' + component)
    }

    return new Promise((resolve, reject) => {
      dataRef.once('value').then((snapshot) => {
        snapshot.forEach((childSnapshot) => {
          dataReturn.push(childSnapshot.val());
        });

        resolve(dataReturn);
      });
    })
  }

  getSingleData(client: any, tokenEvent: string, component: string) {
    let dataRef;

    dataRef = firebase.database().ref().child('/Clients/' + client.url + '/Events/' + tokenEvent).child(component)

    return new Promise((resolve, reject) => {
      dataRef.once('value').then((snapshot) => {
        resolve(snapshot.val());
      });
    })
  }

  getDataRelated(client: any, tokenEvent: string, component: string, equalToChild: any = false, equalToChildRefered: any = false) {
    let dataReturn = [];
    let dataRef: any;
    let dataRelatedRef: any;

    if (equalToChild) {
      dataRef = firebase.database().ref().child('/Clients/' + client.url + '/Events/' + tokenEvent + '/' + component)
        .orderByChild(equalToChild.child)
        .equalTo(equalToChild.value);
    } else {
      dataRef = firebase.database().ref().child('/Clients/' + client.url + '/Events/' + tokenEvent + '/' + component);
    }

    if (equalToChildRefered) {
      dataRelatedRef = firebase.database().ref().child('/Clients/' + client.url + '/' + component).orderByChild(equalToChildRefered.child).equalTo(equalToChildRefered.value);
    } else {
      dataRelatedRef = firebase.database().ref().child('/Clients/' + client.url + '/' + component);
    }

    return new Promise((resolve, reject) => {
      dataRef.once('value')
      .then(snapshot => {
        snapshot.forEach(dataSnapshot => {
          dataRelatedRef.child(dataSnapshot.val().id).once('value')
          .then(dataSnapshot2 => {
            dataReturn.push({
              data: dataSnapshot.val(),
              related: dataSnapshot2.val()
            });
          }).catch(error => {
            reject(error);
          });
        });
      }).catch(error => {
        reject(error);
      });

      resolve(dataReturn);
    });
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/event.ts